// sku.service.ts

import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { ISku, ISkuInput } from "@/interfaces/sku.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class SkuService {
  private baseUrl = "api/v1/sku";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<ISku>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const skus = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return skus;
  }

  async filter(
    filter: IFilter<ISku>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<ISku>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response;
  }

  async create(formData: ISkuInput): Promise<ISku> {
    return await httpRequest.post<ISku>(this.baseUrl, formData);
  }

  async getById(skuId: number): Promise<ISku> {
    const sku = await httpRequest.get(`${this.baseUrl}/${skuId}`);

    return sku;
  }

  async update(formData: ISkuInput, skuId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${skuId}`, formData);
  }

  async delete(skuId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${skuId}`);
  }
}

const skuService = new SkuService();
export default skuService;
